import React, { useState } from "react";
import { Button, Modal } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { logout, selectToken } from "redux-store/features/authSlice";
import UserService from "services/UserService";
import { handleError, useShortDisplay } from "shared/helpers";
import ErrorsComponent from "components/Errors";

function ConfirmDelete({ show, handleClose }) {
  const [loading, setLoading] = useState(false);
  const token = useSelector(selectToken);
  const dispatch = useDispatch();

  const [errors, setErrors] = useState([]);
  useShortDisplay(() => setErrors([]), 5000, errors.length > 0);

  const [messages, setMessages] = useState([]);
  useShortDisplay(() => setMessages([]), 3000, messages.length > 0);

  const handleDelete = async () => {
    setLoading(true);
    try {
      const res = await UserService.deleteMyAccount(token, dispatch);

      if (res.data.success) {
        // Log users out in 3 seconds
        setMessages([res.data.message]);

        setTimeout(() => {
          dispatch(logout());
        }, 3200);
      }
    } catch (error) {
      handleError(error, setErrors);
    }
    setLoading(false);
  };

  return (
    <Modal
      show={show}
      onHide={handleClose}
      backdrop="static"
      keyboard={false}
      centered
    >
      <Modal.Header
        closeButton
        closeVariant="white"
        style={{ borderBottom: "none" }}
      >
        <Modal.Title>Confirm Delete</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <h5 className="mod-detail">This cannot be undone, are you sure?</h5>

        {errors.length > 0 && (
          <div className="mt-2">
            <ErrorsComponent errors={errors} />
          </div>
        )}

        {messages.length > 0 && (
          <div className="mt-2">
            <ErrorsComponent errors={messages} variant="alert-success" />
          </div>
        )}
      </Modal.Body>

      <Modal.Footer style={{ borderTop: "none" }}>
        <Button variant="primary" disabled={loading} onClick={handleDelete}>
          Yes
        </Button>

        <Button variant="secondary" disabled={loading} onClick={handleClose}>
          No
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default ConfirmDelete;
